import type { TradeSessionRegularHours } from '@/utils/tradeSessionStatsDisplay';

export type PeakVolumePricePoint = {
  date: string;
  price: number;
  volume: number;
  pct_of_session_volume?: number | null;
};

export type PeakVolumePriceLevel = {
  price: number;
  volume: number;
  pctOfSessionVolume: number | null;
};

export function peakVolumePriceFromRegularHours(
  rth: TradeSessionRegularHours | undefined | null,
): PeakVolumePriceLevel | null {
  const top = rth?.top_prices_by_volume?.[0];
  if (top?.price == null || top.volume == null) return null;
  const price = Number(top.price);
  const volume = Number(top.volume);
  if (!Number.isFinite(price) || price <= 0 || !Number.isFinite(volume) || volume <= 0) {
    return null;
  }
  const total = rth?.total_volume;
  let pctOfSessionVolume: number | null = null;
  if (total != null && Number(total) > 0) {
    pctOfSessionVolume = (volume / Number(total)) * 100;
  }
  return { price, volume, pctOfSessionVolume };
}

export function formatPeakVolumePriceLabel(price: number): string {
  return `$${price.toFixed(2)}`;
}

export function peakVolumePriceTooltip(
  level: PeakVolumePriceLevel,
  date?: string,
): string {
  const parts = [
    date ? `Peak volume price · ${date}` : 'Peak volume price',
    formatPeakVolumePriceLabel(level.price),
    `${level.volume.toLocaleString()} shares`,
  ];
  if (level.pctOfSessionVolume != null) {
    parts.push(`${level.pctOfSessionVolume.toFixed(1)}% of session volume`);
  }
  return parts.join(' · ');
}
